<!-- Do not change this file. -->

<template>
  <div v-if="show" class="container-fluid vh-100 position-absolute m-0 p-0">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div
        class="border border-primary border-2 bg-primary-subtle h-75 w-75 position-absolute m-5 p-3 rounded-4"
      >
        <div class="container">
          <TheContentManager />
          <div class="mt-5"></div>
          <TheSettingsManager />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

import KeyListener from "@/dev/helpers/KeyListener.vue";
import TheSettingsManager from "@/dev/components/TheSettingsManager.vue";
import TheContentManager from "@/dev/components/TheContentManager.vue";

export default {
  name: "TheToolkit",
  mixins: [KeyListener],
  components: {
    TheSettingsManager,
    TheContentManager
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    doTrigger() {
      this.show = !this.show;
    }
  },
  created() {
    this.setKeyListener([17, 16, 68], this.doTrigger, true); // CTRL, Shift, D
  }
};
</script>
